import React from 'react';
import memoizeOne from 'memoize-one';
import SimpleActions from './SimpleActions';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';

const columns = memoizeOne((handleClick, onlyShow) => [
  {
    name: 'Trabajador',
    selector: 'full_name',
    id: 'full_name',
    cell: item => {
      return (
        <div className="d-flex flex-column" role="presentation">
          <span data-tag="allowRowEvents">{item?.full_name}</span>
          <span className="text-muted" data-tag="allowRowEvents">
            {item?.national_identification || item?.nationalIdentification}
          </span>
          <span className="text-muted" data-tag="allowRowEvents">
            {item?.start_date_contract ? `(${item?.start_date_contract})` : null}
          </span>
        </div>
      );
    },
    grow: '1',
    sortable: true
  },
  {
    name: 'Días trabajados',
    selector: 'worked_days',
    id: 'worked_days',
    grow: '1',
    sortable: true,
    style: {
      justifyContent: 'center'
    }
  },
  {
    name: 'Sueldo Base',
    selector: 'salary_amount',
    id: 'salary_amount',
    grow: '1',
    sortable: true
  },
  {
    name: 'Total imponible',
    selector: 'assets_taxable_total',
    id: 'assets_taxable_total',
    grow: '1',
    sortable: true
  },
  {
    name: 'Total Haberes',
    selector: 'assets_total',
    id: 'assets_total',
    grow: '1',
    sortable: true
  },
  {
    name: 'Desctos. Legales',
    selector: 'discounts_total_legal',
    id: 'discounts_total_legal',
    grow: '1',
    sortable: true
  },
  {
    name: 'Total Desctos.',
    selector: 'discounts_total',
    id: 'discounts_total',
    grow: '1',
    sortable: true
  },
  {
    name: 'Líquido A Pagar',
    selector: 'liquid',
    id: 'liquid',
    grow: '1',
    sortable: true
  },
  {
    name: 'Acciones',
    selector: 'actions',
    cell: item => (
      <SimpleActions handleClick={handleClick} item={camelCaseEmptyStringRecursive(item)} onlyShow={onlyShow} />
    ),
    width: '180px',
    id: 'actions',
    grow: '1'
  }
]);

export default columns;
